import { AUDIENCE_CONTROL_2023_Q1 } from '../../constants/experiments';
import { TAppState } from '../../types/appState';
import { getExperiment } from '../../utils/getExperiment';
import { selectExperiments } from '../experiments';

export function isGroupActionsEnabledSelector(state: TAppState) {
  const experiments = selectExperiments(state);

  const exp = getExperiment(experiments, AUDIENCE_CONTROL_2023_Q1);

  return !exp || exp.groupName === null || exp.groupName === 'none';
}
